module.exports = __webpack_public_path__ + "static/media/logo-olimpia.4cc1b969.png";